import React, { useRef, useState, useEffect, useMemo} from 'react';
import pino from './../assets/images-dresscode/22.svg';
import trajes from './../assets/images-dresscode/23.svg';
import sneaker from './../assets/images-dresscode/24.svg';
import abrigo from './../assets/images-dresscode/25.svg';
import paraguas from './../assets/images-dresscode/26.svg';
import { CButton } from '@coreui/react'


import './dress-code.css';
import { motion } from 'framer-motion'; // Importa motion

const DressCode = () => {

    // Definimos las variantes de animación para el texto
    const textVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.4 } }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.05, // Cada hijo tendrá un retraso de 0.3 segundos respecto al anterior
            }
        }
    };

    const styleButton = {
        '--cui-btn-color': '#fff',
        '--cui-btn-bg': 'var(--azul-prim)',
        'font-family': 'EB Garamond, serif',
        'padding': '0.8rem',
        'font-weight': '600'
    }

  return (
    <motion.div 
        initial="hidden" // El contenedor comienza oculto
        animate="visible" // Anima a visible cuando se monta
        variants={containerVariants} // Usamos las variantes del contenedor
        className='genStyle'
        style={{paddingTop: "4rem", paddingBottom: "4rem"}}>
            <div className="header-seccion">
                <motion.h1  className="bold" variants={textVariants}>
            Código de vestimenta
        </motion.h1>
        <motion.p className='text-lg text-cursiva' variants={textVariants} style={{"marginTop": "1rem"}}>
            <span className="bold" style={{"font-style": "normal"}}>🌲</span> Formal campestre <span style={{"font-style": "normal"}}>🌲</span>
            <br></br>
        </motion.p>
        <motion.p className='text-md' variants={textVariants}>
            Deseamos con el corazón que disfruten cada momento de nuestra celebración entre pinos y aire fresco. Aquí les dejamos los mejores consejos para lucir guapísimos y cómodos en nuestro día especial.
        </motion.p>
            </div>
        
        <div className="indicaciones">

            <motion.div
                initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: false, amount: 0.2 }}
                    transition={{
                        type: "spring",
                        stiffness: 20,   // Lower = more "rubbery", Higher = more "snappy"
                        damping: 10,     // Resistance to the spring (prevents endless bouncing)
                        mass: 0.1,         // Heavier mass takes longer to speed up/slow down
                        restDelta: 0.1// Ensures the animation finishes cleanly
                    }}
                className='rightLayout'
            >
                
                    <img src={pino} alt="" className="pino" /> 
                <p className='text-md' variants={textVariants}>
                    Queremos recordarles que nuestra boda será en el corazón de la naturaleza, por lo que el terreno será rústico -con desniveles, cascadas, calles empedradas, altos pinos, terracería, escalones de piedra y jardines frondosos-.
                </p>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{
                        type: "spring",
                        stiffness: 20,   // Lower = more "rubbery", Higher = more "snappy"
                        damping: 10,     // Resistance to the spring (prevents endless bouncing)
                        mass: 0.4,         // Heavier mass takes longer to speed up/slow down
                        restDelta: 0.001 // Ensures the animation finishes cleanly
                    }}
                className='leftLayout'
            >
                    <p className='text-md' variants={textVariants}>
                        Les pedimos de manera muy especial que eviten los colores blanco y beige en sus atuendos. ¡Dejemos eso para los novios!
                        <br></br><br></br>
                        De igual forma, les solicitamos amablemente elegir un color de vestido distinto a la gama de azules, ya que estos tonos han sido reservados exclusivamente para nuestras damas de honor.
                        <br></br><br></br>
                        En calzado y camisas, está totalmente permitido elegir cualquier color. Sugerimos optar por vestidos de noche o trajes formales. Les recomendamos mucho cuidar que el largo de su vestido o pantalón sea el adecuado para caminar y bailar cómodamente con el calzado que elijan. ¡Queremos que disfruten cada rincón del bosque!
                    </p>
                    
                   <img src={trajes} alt="" className="trajes" /> {/* Estilos CSS para el SVG aquí */}
                
            </motion.div>
            
            <motion.div
                initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: false, amount: 0.2}}
                    transition={{
                        type: "spring",
                        stiffness: 20,   // Lower = more "rubbery", Higher = more "snappy"
                        damping: 10,     // Resistance to the spring (prevents endless bouncing)
                        mass: 0.4,         // Heavier mass takes longer to speed up/slow down
                        restDelta: 0.001 // Ensures the animation finishes cleanly
                    }}
                className='rightLayout'
            >
                    <img src={sneaker} alt="" className="sneaker" />
                
                <div className='atuendosDiv'>
                    <motion.p className='text-md' variants={textVariants}>
                        Para pulir la pista de baile con nosotros, les invitamos a combinar su atuendo formal con tenis. ¡Sí, leyeron bien! Queremos ver su estilo más auténtico y cómodo. De hecho, ¡los propios novios los usarán! Si son blancos, ¡mejor aún! Sin embargo, si optan por llevar otro tipo de calzado, les pedimos evitar tacones de aguja o demasiado altos. Tacones anchos bajos o zapatos bajos antiderrapantes serían la mejor opción.
                    </motion.p>
                    <CButton style={styleButton} href="https://pin.it/63VnDqNCu" target="_blank">¡Mira lo geniales que se ven👟!</CButton>
                </div>
            </motion.div>
            
            <motion.div
                initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: false, amount: 0.2 }}
                    transition={{
                        type: "spring",
                        stiffness: 20,   // Lower = more "rubbery", Higher = more "snappy"
                        damping: 10,     // Resistance to the spring (prevents endless bouncing)
                        mass: 0.4,         // Heavier mass takes longer to speed up/slow down
                        restDelta: 0.001 // Ensures the animation finishes cleanly
                    }}
                className='leftLayout'
            >
                <p className='text-md' variants={textVariants}>
                    Les recomendamos traer también varias opciones abrigadoras para cuando caiga la tarde y la neblina nos acompañe. Mineral del Chico tiene un clima muy fresco, de montaña, que, en mayo, oscila entre 8°C y 23°C.
                </p>
               
                    <img src={abrigo} alt="" className="abrigo" />
                
            </motion.div>
            
            <motion.div
               initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: false, amount: 0.2 }}
                    transition={{
                        type: "spring",
                        stiffness: 20,   // Lower = more "rubbery", Higher = more "snappy"
                        damping: 10,     // Resistance to the spring (prevents endless bouncing)
                        mass: 0.4,         // Heavier mass takes longer to speed up/slow down
                        restDelta: 0.001 // Ensures the animation finishes cleanly
                    }}
                className='rightLayout'
            >
                    <img src={paraguas} alt="" className="paraguas" /> {/* Estilos CSS para el SVG aquí */}
                
                <p className='text-md paraguastext' variants={textVariants}>
                    No olviden empacar también un paraguas, sólo por precaución. ¡Mineral del Chico es impredecible! Mayo es un mes con baja probabilidad de lluvias, ¡pero nunca cero!
                </p> 
            </motion.div>
        </div>
    </motion.div>
  );
};

export default DressCode;